import Image from "next/image";
import Link from "next/link";
import img from "../../assets/icons/arrow-right-half-white.svg";
import iconNewTab from "../../assets/icons/new-tab.png";
import { useSelector } from "react-redux";
import { processFooter } from "../../utils/mapping";
import { useRouter } from "next/router";
import style from "./CommonFooter.module.scss";
import Facebook from "@/assets/images/facebook_icon.webp";
import Instagram from "@/assets/images/instagram_icon.webp";
import Linkedin from "@/assets/images/linkedin_icon.webp";
import Youtube from "@/assets/images/youtube_icon.webp";

const CommonFooter = () => {
  const { isFooter } = useSelector((state: any) => state.data);
  const router = useRouter();
  const processedData = processFooter(isFooter);
  
 
  return (
    <div className={` ${style.footer}`} data-testid="footer-container-id">
      <div className={` ${style.footerTop}`} data-testid="footer-top-id">
        <div className="footer_wp">
          <div className={`${style.rightPaneColumn}`}>
            <div className={` ${style.quicklinks}`}>
              <div className={` ${style.quicklinksitem}`}>
                {processedData?.firstColumn?.submenu?.results?.map(
                  (item: any, index: any) => {
                    return (
                      <ul key={index}>
                        <li>
                          <Link
                            href={item?.hyperlink || "#"}
                            className={`${style.mainLink} ${item?.class}`}
                            target={item?.externallink === true ? "_blank" : ""}
                            rel={
                              item?.externallink === true
                                ? "noopener noreferrer"
                                : ""
                            }
                          >
                            {item?.name}
                            {item?.class == "footer_links external_icon" && (
                              <span className="ps-1">
                                <Image
                                  src={iconNewTab}
                                  alt="icon"
                                  height={12}
                                  width={12}
                                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                />
                              </span>
                            )}
                          </Link>
                        </li>
                        <ul>
                          {item?.submenu?.results?.map(
                            (sub_item: any, index: any) => {
                              return (
                                <li key={index}>
                                  <Link
                                    href={sub_item?.hyperlink || "#"}
                                    className={` ${style.footerLink}`}
                                    target={
                                      sub_item?.externallink === true
                                        ? "_blank"
                                        : ""
                                    }
                                    rel={
                                      sub_item?.externallink === true
                                        ? "noopener noreferrer"
                                        : ""
                                    }
                                  >
                                    {sub_item?.name}
                                    {sub_item?.class == "footer_links external_icon" && (
                                      <span className="ps-1">
                                        <Image
                                          src={iconNewTab}
                                          alt="icon2"
                                          height={12}
                                          width={12}
                                          // placeholder="empty"
                                          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                        />
                                      </span>
                                    )}
                                  </Link>
                                </li>
                              );
                            }
                          )}
                        </ul>
                      </ul>
                    );
                  }
                )}
              </div>
            </div>
            <div className={` ${style.leftPaneColumn}`}>
              <div className={` ${style.rightPane}`}>
                {processedData?.secondColumn?.submenu?.results?.map(
                  (item: any, index: any) => {
                    return (
                      <ul key={index} className={` ${style.title}`}>
                        <li>
                          <Link
                            href={item?.hyperlink || "#"}
                            className={`${style.columntitle} ${item?.class} ${
                              item?.hyperlink ? style.columntitleHover : ""
                            }`}
                            target={item?.externallink === true ? "_blank" : ""}
                            rel={
                              item?.externallink === true
                                ? "noopener noreferrer"
                                : ""
                            }
                          >
                            {item?.name}
                            {item?.class == "footer_links external_icon" && (
                              <span className="ps-1">
                                <Image
                                  src={iconNewTab}
                                  alt="icon3"
                                  height={12}
                                  width={12}
                                  // placeholder="empty"
                                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                />
                              </span>
                            )}
                          </Link>
                        </li>
                        {item?.submenu?.results?.map(
                          (sub_item: any, index: any) => {
                            return (
                              <ul
                                key={index}
                                className={` ${style.subtitle} ${sub_item?.class} `}
                              >
                                <li>
                                  <Link
                                    href={sub_item?.hyperlink || "#"}
                                    target={
                                      sub_item?.externallink === true
                                        ? "_blank"
                                        : ""
                                    }
                                    rel={
                                      sub_item?.externallink === true
                                        ? "noopener noreferrer"
                                        : ""
                                    }
                                  >
                                    {sub_item?.name}
                                    {sub_item?.class == "footer_links external_icon" && (
                                      <span className="ps-1">
                                        <Image
                                          src={iconNewTab}
                                          alt="icon4"
                                          height={12}
                                          width={12}
                                          // placeholder="empty"
                                          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                        />
                                      </span>
                                    )}
                                  </Link>
                                </li>
                              </ul>
                            );
                          }
                        )}
                      </ul>
                    );
                  }
                )}
              </div>
              <div className={` ${style.rightPane}`}>
                {processedData?.thirdColumn?.submenu?.results?.map(
                  (item: any, index: any) => {
                    return (
                      <ul key={index} className={` ${style.title}`}>
                        <li>
                          <Link
                            href={item?.hyperlink || "#"}
                            className={`${style.columntitle} ${item?.class} ${
                              item?.hyperlink ? style.columntitleHover : ""
                            }`}
                            target={item?.externallink === true ? "_blank" : ""}
                            rel={
                              item?.externallink === true
                                ? "noopener noreferrer"
                                : ""
                            }
                          >
                            {item?.name}
                            {item?.class == "footer_links external_icon" && (
                              <span className="ps-1">
                                <Image
                                  src={iconNewTab}
                                  alt="icon5"
                                  height={12}
                                  width={12}
                                  // placeholder="empty"
                                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                />
                              </span>
                            )}
                          </Link>
                        </li>
                        {item?.submenu?.results?.map(
                          (sub_item: any, index: any) => {
                            return (
                              <ul
                                key={index}
                                className={` ${style.subtitle} ${sub_item?.class}`}
                              >
                                <li>
                                  <Link
                                    href={sub_item?.hyperlink || "#"}
                                    target={
                                      sub_item?.externallink === true
                                        ? "_blank"
                                        : ""
                                    }
                                    rel={
                                      sub_item?.externallink === true
                                        ? "noopener noreferrer"
                                        : ""
                                    }
                                  >
                                    {sub_item?.name}
                                    {sub_item?.class == "footer_links external_icon" && (
                                      <span className="ps-1">
                                        <Image
                                          src={iconNewTab}
                                          alt="icon6"
                                          height={12}
                                          width={12}
                                          // placeholder="empty"
                                          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                        />
                                      </span>
                                    )}
                                  </Link>
                                </li>
                              </ul>
                            );
                          }
                        )}
                      </ul>
                    );
                  }
                )}
              </div>
              <div className={`${style.rightPane} ${style.rightPanethird}`}>
                {processedData?.fourthColumn?.submenu?.results?.map(
                  (item: any, index: any) => {
                    return (
                      <ul
                        key={index}
                        className={` ${style.maintitle}  ${item?.class}`}
                      >
                        <li>
                          <Link
                            href={item?.hyperlink || "#"}
                            className={`${style.columntitle} ${
                              item?.hyperlink ? style.columntitleHover : ""
                            }`}
                            target={item?.externallink === true ? "_blank" : ""}
                            rel={
                              item?.externallink === true
                                ? "noopener noreferrer"
                                : ""
                            }
                          >
                            {item?.name}
                            {item?.class == "footer_links external_icon" && (
                              <span className="ps-1">
                                <Image
                                  src={iconNewTab}
                                  alt="icon7"
                                  height={12}
                                  width={12}
                                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                />
                              </span>
                            )}
                          </Link>
                        </li>
                        {item?.submenu?.results?.map(
                          (sub_item: any, index: any) => {
                            return (
                              <ul
                                key={index}
                                className={` ${style.subtitle} ${sub_item?.class}`}
                              >
                                <li>
                                  <Link
                                    href={sub_item?.hyperlink || "#"}
                                    target={
                                      sub_item?.externallink === true
                                        ? "_blank"
                                        : ""
                                    }
                                    rel={
                                      sub_item?.externallink === true
                                        ? "noopener noreferrer"
                                        : ""
                                    }
                                  >
                                    {sub_item?.name}
                                    {sub_item?.class == "footer_links external_icon" && (
                                      <span className="ps-1">
                                        <Image
                                          src={iconNewTab}
                                          alt="icon8"
                                          height={12}
                                          width={12}
                                          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                        />
                                      </span>
                                    )}
                                  </Link>
                                </li>
                              </ul>
                            );
                          }
                        )}
                      </ul>
                    );
                  }
                )}
              </div>
              <div className={` ${style.rightPane} ${style.rightPanethird}`}>
                {processedData?.fifthColumn?.submenu?.results?.map(
                  (item: any, index: any) => {
                    return (
                      <ul key={index} className={` ${style.maintitle}`}>
                        <li>
                          <Link
                            href={item?.hyperlink || "#"}
                            className={`${style.columntitle} ${item?.class}${
                              item?.hyperlink ? style.columntitleHover : ""
                            }`}
                            target={item?.externallink === true ? "_blank" : ""}
                            rel={
                              item?.externallink === true
                                ? "noopener noreferrer"
                                : ""
                            }
                          >
                            {item?.name}
                            {item?.class == "footer_links external_icon" && (
                              <span className="ps-1">
                                <Image
                                  src={iconNewTab}
                                  alt="icon8"
                                  height={12}
                                  width={12}
                                  // placeholder="empty"
                                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                />
                              </span>
                            )}
                          </Link>
                        </li>
                        {item?.submenu?.results?.map(
                          (sub_item: any, index: any) => {
                            return (
                              <ul
                                key={index}
                                className={` ${style.subtitle} ${sub_item?.class}`}
                              >
                                <li>
                                  <Link
                                    href={sub_item?.hyperlink || "#"}
                                    target={
                                      sub_item?.externallink === true
                                        ? "_blank"
                                        : ""
                                    }
                                    rel={
                                      sub_item?.externallink === true
                                        ? "noopener noreferrer"
                                        : ""
                                    }
                                  >
                                    {sub_item?.name}
                                    {sub_item?.class == "footer_links external_icon" && (
                                      <span className="ps-1">
                                        <Image
                                          src={iconNewTab}
                                          alt="icon9"
                                          height={12}
                                          width={12}
                                          // placeholder="empty"
                                          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                        />
                                      </span>
                                    )}
                                  </Link>
                                </li>
                              </ul>
                            );
                          }
                        )}
                      </ul>
                    );
                  }
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={` ${style.footerBottom}`} data-testid="footer-bottom-id">
        <div className="container-fluid">
          <div className={` ${style.footerLink}`}>
            <div className={` order-4 order-lg-0 ${style.box}`}>
              <p>{processedData?.termsConditions?.newssubscriptiontitle || `SUBSCRIBE TO OUR NEWSLETTER`}</p>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  aria-label="Recipient's username"
                  aria-describedby="basic-addon2"
                />
                <span
                  className={`input-group-text ${style.inputGroup}`}
                  id="basic-addon2"
                >
                  <Image
                    src={img}
                    alt="call"
                    width={30}
                    height={30}
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  />
                </span>
              </div>
            </div>
            <div className={` order-2 order-lg-1 ${style.box}`}>
              <p>{processedData?.termsConditions?.followUsOnTitle || `FOLLOW US ON`}</p>
              <div className={` ${style.social}`}>
                <Link
                  href={
                    processedData?.termsConditions?.facebookLink?.results[0]
                      ?.hyperlink || "#"
                  }
                  target="_blank"
                  className={style?.socialIcon}
                >
                  <Image 
                   src={processedData?.termsConditions?.facebookIcon?.results?.[0]?.fileUrl || Facebook}
                   alt="facebook"
                   width={24}
                   height={24}
                  />
                </Link>
                <Link
                  href={
                    processedData?.termsConditions?.instagramLink?.results[0]
                      ?.hyperlink || "#"
                  }
                  target="_blank"
                  className={style?.socialIcon}
                >
                   <Image 
                   src={processedData?.termsConditions?.instagramIcon?.results?.[0]?.fileUrl || Instagram}
                   alt="instagram"
                   width={24}
                   height={24}
                  />
                </Link>
                <Link
                  href={
                    processedData?.termsConditions?.twitterLink?.results[0]
                      ?.hyperlink || "#"
                  
                    }
                    target="_blank"
                    className={style?.socialIcon1}
                >
                  <Image 
                   src={processedData?.termsConditions?.twitterIcon?.results?.[0]?.fileUrl || Youtube}
                   alt="youtube"
                   width={24}
                   height={24}
                  />
                </Link>

                <Link
                  href={
                    processedData?.termsConditions?.linkedinLink?.results[0]
                      ?.hyperlink || "#"
                  }
                  target="_blank"
                  className={style?.socialIcon}
                >

                  <Image 
                   src={processedData?.termsConditions?.linkedinIcon?.results?.[0]?.fileUrl || Linkedin}
                   alt="linkedin"
                   width={24}
                   height={24}
                  />
                </Link>
                <div>
                  <button
                    type="button"
                    className="carrer-link"
                    onClick={() => router?.push("/careers")}
                  >
                    <span>Career</span>
                  </button>
                </div>
              </div>
            </div>
            <div className={` order-0 order-lg-2 ${style.box}`}>
              <p>{processedData?.termsConditions?.emailTitle || `EMAIL`}</p>

              <Link
                href={
                  processedData?.termsConditions?.emailId
                    ? `mailto:${processedData?.termsConditions?.emailId}`
                    : "#"
                }
              >
                {" "}
                {processedData?.termsConditions?.emailId || `customercare@aldar.com`}
              </Link>
            </div>
            <div className={` order-1 order-lg-3 ${style.box}`}>
              <p>{processedData?.termsConditions?.phoneTitle || `PHONE`}</p>

              {/* <Link href={`tel:${800-25327}` || "#"}>
                {processedData?.termsConditions?.phoneNumber || `800-ALDAR / 800-25327`}
              </Link> */}

<Link href={`${processedData?.termsConditions?.phonenumberlink}` || "#"}>
                {processedData?.termsConditions?.phoneNumber || `+9718008535`}
              </Link>


            </div>
            <div className={`order-3 order-lg-4 ${style.box}`}>
              <p className="mobile-hidden"></p>
              <button
                type="button"
                className={` ${style.hover} ${style.contact}`}
                onClick={() =>
                  router?.push(
                    processedData?.termsConditions?.contactUs?.results[0]
                      ?.hyperlink
                  )
                }
              >
                <span>
                  {processedData?.termsConditions?.contactUs?.results[0]?.name || `Contact Us`}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className={` ${style.footerBottomsec}`}
        data-testid="footer-bottomsec-id"
      >
        <div className="container-fluid" data-testid="footer-fluid-id">
          <div className={` ${style.footerLinksec}`}>
            <div className={`order-2 order-lg-0 ${style.footerLinkitem}`}>
              <Link
                href={
                  processedData?.termsConditions?.privacyPolicy?.results[0]
                    .hyperlink || "#"
                }
              >
                {
                  processedData?.termsConditions?.privacyPolicy?.results[0]
                    ?.name || `Privacy Policy`
                }
              </Link>
              <Link
                href={
                  processedData?.termsConditions?.termsOfUse?.results[0]
                    .hyperlink || "#"
                }
              >
                {processedData?.termsConditions?.termsOfUse?.results[0].name || `Terms of Use`}
              </Link>
            </div>
            <div className={`order-0 order-lg-1 ${style.footerLinkitem}`}>
              <p className="mb-0">
                {processedData?.termsConditions?.copyright || `Copyright © 2024 Aldar Properties. All Rights Reserved.`}
              </p>
            </div>
            <div className={`order-1 order-lg-2 ${style.footerLinkitem}`}>
              <p className="mb-0">
                {processedData?.termsConditions?.recaptchaText || `This site is protected by reCAPTCHA & Google Privacy Policy & Terms of Service`}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonFooter;
